/**
 * 站点首页 — English (shared PC / M, t('index.…'))
 */
export default {
	energy: {
		title: "Daily Energy",
		mohu: "Login to unlock all energy values",
		todayLabel: "Daily Energy",
		tip: "Renovation is not recommended today. Planting flowers and greenery can help adjust your energy field and boost your overall aura.",
		viewDetail: "View Today's Energy Details",
		supplementProfile: "Please complete your profile",
		addProfile: "Add a profile to view energy values",
		categories: {
			emotion: "Romance",
			career: "Career",
			wealth: "Wealth",
			travel: "Travel",
			health: "Health",
		},
		ts: {
			title: "Tongsheng",
			good: "Suitable",
			bad: "Taboo",
			viewAll: "View Full Tongsheng",
			ganzhi: {
				year: "Year",
				month: "Month",
				day: "Day",
			},
		},
	},
	masters: {
		greeting: "What Problem Do You Need to Solve?",
		placeholder: "Enter your question...",
		guide: {
			line1: "World's 1st AI",
			line2: "— MasterS",
		},
		tags: {
			bazi: "BaZi",
			tarot: "Tarot",
			liuyao: "Liu Yao",
			chat: "Chat",
		},
	},
	teacherConsultation: {
		title: "Global Professional Mentors",
		title2: "Connect with masters worldwide for life guidance",
		consultButton: "View Details",
		consultButton2: "Ask",
		defaultName: "Master",
		defaultTags: {
			emotion: "Relationship",
			wealth: "Wealth",
			life: "Life Guidance",
		},
		summary: {
			years: "{year} years of experience",
			users: "{users} consults",
			fallback: "Professional master offering one-on-one consultations",
		},
	},
	fameTeacher: {
		title: "Find the right professional mentor quickly by popularity and field",
		title1: "Popular Mentor Ranking",
		title2: "Choose the topic you want to consult about",
		consultUnit: " consultations",
		viewTeachers: "View Mentors",
		viewMore: "View More Mentors",
		join: {
			title: "Apply to Become a Mentor",
			desc: "Share your expertise and help more people open a new direction in life",
			button: "Apply to Become a Mentor Now",
			buttonMobile: "Apply Now",
		},
		stats: {
			masters: {
				value: "200+",
				label: "Professional Mentors",
			},
			privacy: {
				value: "Privacy Protection",
				label: "Consultation Content Kept Confidential",
			},
			satisfaction: {
				value: "High Satisfaction",
				label: "Positive Reviews from Real Users",
			},
			users: {
				value: "2000K+",
				label: "core users",
			},
		},
		topics: {
			love: {
				title: "Love & Relationships",
				desc: "Relationship development & compatibility, interpersonal relationships & getting-along advice",
			},
			career: {
				title: "Career & Wealth",
				desc: "Career development & job change advice, wealth trends & financial planning",
			},
			health: {
				title: "Family & Health",
				desc: "Family relationships & harmony advice, health status & wellness guidance",
			},
			decision: {
				title: "Decision-Making & Questions",
				desc: "Important decisions & timing judgment, event development & outcome prediction",
			},
		},
	},
	more: {
		box1: {
			title: "Professional Calculation Tools",
			title2: "Analyze your life path from multiple dimensions and find your direction in life",
			useButton: "Use Now",
			bazi: {
				title: "BaZi Chart",
				desc1: "Accurate charting to analyze the Five Elements of your destiny chart",
				desc2: "Ten Gods patterns and in-depth fortune analysis",
			},
			tarot: {
				title: "Tarot Reading",
				desc1: "Accurate readings with 78 Tarot cards",
				desc2: "Full analysis of love, career, and fortune",
			},
		},
		box2: {
			title: "AI + Large Model Calculation",
			items: {
				love: {
					title: "Love Guidance",
					desc1: "Analyze relationship patterns",
					desc2: "Meet the right person",
				},
				career: {
					title: "Career Planning",
					desc1: "Analyze your talents and strengths",
					desc2: "Plan your path to success",
				},
				wealth: {
					title: "Wealth Insights",
					desc1: "Understand wealth trends",
					desc2: "Enhance wealth energy",
				},
				annual: {
					title: "Annual Fortune",
					desc1: "Annual fortune analysis",
					desc2: "Seize key opportunities",
				},
				ziwei: {
					title: "Zi Wei Chart",
					desc1: "Detailed Zi Wei Dou Shu reading",
					desc2: "Destiny pattern analysis",
				},
				bazi: {
					title: "Detailed BaZi Reading",
					desc1: "Detailed Four Pillars BaZi analysis",
					desc2: "Comprehensive destiny analysis",
				},
				tarot: {
					title: "Tarot Astrology",
					desc1: "Tarot card guidance",
					desc2: "Combined with astrological insights",
				},
				funTest: {
					title: "Fun Quizzes",
					desc1: "Rich fun quizzes",
					desc2: "Explore your inner thoughts",
				},
				more: {
					title: "More Calculations",
					desc1: "Explore more tools",
					desc2: "Unlock life answers",
				},
			},
		},
	},
	topTeacher: {
		title: "Recommended Mentors",
		title2:
			"Featured mentors and popular videos to help you explore life wisdom and find your direction in life",
		viewProfile: "View Details",
		videoTitle: "Popular Videos",
		viewMoreVideos: "View More",
		viewUnit: " views",
		noVideos: "No videos yet",
	},
	privilege: {
		title: "App-Exclusive Benefits",
		ctaTitle: "Ready to explore your life's direction?",
		ctaDesc: "Download the SeerQ app now and start your journey of wisdom",
		downloadOn: "Download On The",
		apkLabel: "Download APK",
		features: {
			bean: {
				title1: "Collect Fortune Beans",
				title2: "Redeem Grand Prizes",
			},
			vip: {
				title1: "Free Trial",
				title2: "Membership Services",
			},
			pray: {
				title1: "Prayer Altar",
				title2: "Daily Blessings",
			},
			live: {
				title1: "Master Live Oncall",
				title2: "Free 3 Minutes",
			},
			meditation: {
				title1: "Meditation Space",
				title2: "Daily Healing",
			},
		},
	},
	sidebar: {
		ariaLabel: "Quick actions sidebar",
		support: {
			title: "Customer Support",
			subtitle: "Live Chat",
		},
		order: {
			title: "Order Inquiry",
			subtitle: "View Orders",
		},
		download: {
			title: "App Download",
			subtitle: "Scan QR Code",
		},
		top: {
			title: "Top",
			subtitle: "Back to Top",
		},
	},
	appDownloadModal: {
		title: "This feature is not yet available. Download our app for early access.",
		close: "Close",
		back: "Back",
		goToApp: "Go to App",
	},
};
